// extracted by mini-css-extract-plugin
export default {"toast":"styles_toast__uQ6mH"};